import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import styles from './Table.module.css';
import ConfirmDialog from '../components/ConfirmDialog';

export default function BlockedUsers() {
  const [blocks, setBlocks] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [confirm, setConfirm] = useState(null);
  const navigate = useNavigate();

  const load = useCallback(async (p = 1) => {
    setLoading(true);
    try {
      const { data } = await api.get(`/blocks/admin?page=${p}&limit=30`);
      setBlocks(data.blocks || []);
      setTotal(data.total || 0);
      setPages(data.pages || 1);
      setPage(p);
    } catch {
      alert('Failed to load blocked users');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load(1);
  }, [load]);

  const remove = (row) => {
    setConfirm({
      message: `Remove block: ${row.blocker?.name || 'User'} → ${row.blocked?.name || 'User'}?`,
      onConfirm: async () => {
        setConfirm(null);
        try {
          await api.delete(`/blocks/admin/${row.id}`);
          load(page);
        } catch {
          alert('Failed');
        }
      },
    });
  };

  return (
    <div>
      {confirm && (
        <ConfirmDialog
          message={confirm.message}
          onConfirm={confirm.onConfirm}
          onCancel={() => setConfirm(null)}
        />
      )}
      <div className={styles.header}>
        <h2 className={styles.title}>
          Blocked Users <span style={{ fontSize: 14, color: '#888', fontWeight: 400 }}>({total})</span>
        </h2>
      </div>
      <p style={{ color: '#888', fontSize: 13, marginTop: -8, marginBottom: 16 }}>
        User-to-user blocks from the app. Removing a row unblocks that pair only.
      </p>

      {loading ? (
        <div className={styles.center}>Loading...</div>
      ) : (
        <>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Blocker</th>
                  <th>Blocked user</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {blocks.length === 0 && (
                  <tr>
                    <td colSpan={4} className={styles.empty}>
                      No blocks yet
                    </td>
                  </tr>
                )}
                {blocks.map((b) => (
                  <tr key={b.id}>
                    <td>
                      <button
                        type="button"
                        className={styles.adTitleBtn}
                        onClick={() => b.blocker?.id && navigate(`/users/${b.blocker.id}`)}
                      >
                        {b.blocker?.name || '—'}
                      </button>
                      <div style={{ fontSize: 12, color: '#aaa' }}>{b.blocker?.email}</div>
                    </td>
                    <td>
                      <button
                        type="button"
                        className={styles.adTitleBtn}
                        onClick={() => b.blocked?.id && navigate(`/users/${b.blocked.id}`)}
                      >
                        {b.blocked?.name || '—'}
                      </button>
                      <div style={{ fontSize: 12, color: '#aaa' }}>{b.blocked?.email}</div>
                    </td>
                    <td style={{ fontSize: 12 }}>
                      {b.createdAt ? new Date(b.createdAt).toLocaleString() : '—'}
                    </td>
                    <td>
                      <button type="button" className={styles.deleteBtn} onClick={() => remove(b)}>
                        Remove block
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {pages > 1 && (
            <div className={styles.pagination}>
              <button type="button" className={styles.filterBtn} disabled={page <= 1} onClick={() => load(page - 1)}>
                ← Prev
              </button>
              <span>
                Page {page} of {pages}
              </span>
              <button type="button" className={styles.filterBtn} disabled={page >= pages} onClick={() => load(page + 1)}>
                Next →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
